import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import GoldZakatTable from "./GoldZakatTable";
import { SERVER_URL } from "./ConstantsIslamicCalculator";
import { Gold_Zakat_EndPoint } from "./ConstantsIslamicCalculator";
import SharedHelmet from "../Helmet";
const TITLE = 'Calcul de Zakat sur l\'or 2026 - Calculatrice du seuil de Zakat sur l\'or';
const DESCRIPTION =
  "Calcul de Zakat sur l\\ pour effectuer vos calculs islamiques de facon claire et rapide. Outil pratique pour verifier vos donnees et obtenir un resultat fiable en ligne.";
const KEYWORDS =
  "calcul de zakat sur l\\, calculatrice calcul de zakat sur l\\, calcul en ligne, zakat, heritage, calcul islamique, resultat rapide";
const OG_URL = 'https://do-calculate.com/calculator/fr/gold-zakat/';
const apiEndpoint = `${SERVER_URL}/${Gold_Zakat_EndPoint}`;
function GoldZakatCalculator() {
    const [yearType, setYearType] = useState('');
    const [gramPriceGold, setGramPriceGold] = useState(0);
    const [gramPriceSilver, setGramPriceSilver] = useState(0);
    const [result, setRestul] = useState(null);
    const [error, setError] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [goldWeights, setGoldWeights] = useState([0, 0, 0, 0, 0, 0]);
    const goldKarats = [24, 22, 21, 18, 14, 10];
    const handleWeightsChange = (index, weight) => {
        const updatedWeights = [...goldWeights];
        updatedWeights[index] = parseFloat(weight);
        setGoldWeights(updatedWeights);
    };
    const handleYearTypeChange = (event) => {
        setYearType(event.target.value);
    };
    const handleGramPriceGoldChange = (event) => {
        setGramPriceGold(event.target.value);
    };
    const handleGramPriceSilverChange = (event) => {
        setGramPriceSilver(event.target.value);
    };
    const calculateGoldZakat = async () => {
        const convertedGoldWeights = goldWeights.map((weight) => Number(weight));
        setIsLoading(true);
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ goldWeights: convertedGoldWeights, goldKarats, gramPriceGold, yearType }),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                setRestul(data.result);
                setError(null);
            } else {
                setRestul(null);
                setError(data.error);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div className="ltr">
            <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px', }}>
                        <h1 style={{ fontSize: '15px' }}>  Calculez la zakat sur l'or pour tout carat </h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                <p>
                                    La calculatrice zakat or est un outil avancé et précis conçu spécifiquement pour faciliter le calcul du montant de zakat due sur l'or, en conformité complète avec les règles de la loi islamique. Suivez les étapes simples suivantes pour utiliser la calculatrice:
                                </p>
                                <ul>
                                    <li>
                                        <strong>Entrez le poids d'or:</strong> Spécifiez le poids total de l'or que vous possédez en grammes.
                                    </li>
                                    <li>
                                        <strong>Choisissez le carat d'or:</strong> Sélectionnez parmi les différents carats comme 21, 22 ou 24 carats pour déterminer le type d'or.
                                    </li>
                                    <li>
                                        <strong>Entrez le prix au gramme:</strong> Entrez le prix actuel au gramme pour le carat que vous avez choisi.
                                    </li>
                                    <li>
                                        <strong>Calculez la zakat:</strong> Cliquez sur le bouton "Calculer la zakat" pour connaître le montant due à payer comme zakat.
                                    </li>
                                    <li>
                                        <strong>Vérifiez les résultats:</strong> Examinez le montant de zakat a payer et assurez-vous de l'exactitude des données entrées.
                                    </li>
                                </ul>
                                <p>
                                    Grâce à cet outil, vous pouvez être assuré que vous respectez pleinement les enseignements de l'Islam et que vous remplissez votre obligation religieuse concernant la zakat sur l'or, sans complication ni effort.
                                </p>
                                <br />
                                <hr />
                            </div>
                            <br />
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-5 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    <h2 style={{ fontSize: '15px' }}>Calculatrice Zakat sur l'or</h2>
                                </div>
                                <hr />
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='yearType' >Type d'année</label>
                                    </b>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="yearType"
                                            value="gregorian"
                                            id="gregorian"
                                            checked={yearType === "gregorian"}
                                            onChange={handleYearTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="gregorian">
                                            Grégorienne
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="yearType"
                                            value="hijri"
                                            id='hijri'
                                            checked={yearType === "hijri"}
                                            onChange={handleYearTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="hijri">
                                            Hijri
                                        </label>
                                    </div>
                                </div>
                                <br />
                                <div>
                                    {goldKarats.map((karat, index) => (
                                        <div key={index}>
                                            <div className="form-group d-flex align-items-center">
                                                <b>
                                                    <label htmlFor="amoutNumber" className="form-label ms-2">{`Poids d'or carat ${karat}`}</label>
                                                </b>
                                                <input
                                                    type="number"
                                                    id="amoutNumber"
                                                    value={goldWeights[index]}
                                                    onChange={(e) => handleWeightsChange(index, e.target.value)}
                                                    className="form-control ml-2"
                                                    style={{ width: '150px' }}
                                                />
                                                <div className="input-group-append">
                                                    <span className="input-group-text">g</span>
                                                </div>
                                            </div>
                                            <br />
                                        </div>
                                    ))}
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='gramPriceGoldNumber' className="form-label ms-2">Prix du gramme d'or (24 carats)</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="gramPriceGoldNumber"
                                        value={gramPriceGold}
                                        onChange={handleGramPriceGoldChange}
                                        className="form-control ml-2"
                                        style={{ width: '150px' }}
                                    />
                                </div>
                                <br/>
                                <hr />
                                <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={
                                    calculateGoldZakat} disabled={isLoading}>
                                    {isLoading ? (
                                        <div className="spinner-border spinner-border-sm" role="status">
                                            <span className="visually-hidden">Chargement...</span>
                                        </div>
                                    ) : (
                                        'Calculer'
                                    )}
                                </button>
                            </div>
                            <div className="col-sm-12 col-md-7">
                                <br />
                                {statusCode === 400 && <div className="alert alert-warning"><b><u> Erreur :</u></b> Veuillez remplir tous les champs correctement. </div>}
                                {result &&
                                    (
                                        <div>
                                            <h4><div className="p-3 mb-2 bg-success text-white">Résultats: </div></h4>
                                            <hr />
                                            <GoldZakatTable result={result}></GoldZakatTable>
                                        </div>
                                    )}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <br />
                    <MainCalculatorsList />
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">
                                <h2 style={{ fontSize: "18px" }}>{TITLE}</h2>
                            </div>
                            <div className="info-section-body">
                                <p>{DESCRIPTION}</p>
                                <div>
                                    <h3 style={{ fontSize: '16px' }}>Comment calculer la Zakat sur l'or</h3>
                                    <p>Pour calculer la zakat sur l'or, vous devez connaître certains facteurs de base tels que:</p>
                                    <ul>
                                        <li><strong>Poids de l'or:</strong> Le poids total de l'or que vous possédez.</li>
                                        <li><strong>Carat d'or:</strong> Le rapport de pureté dans l'or, comme 21, 22 ou 24 carats.</li>
                                        <li><strong>Prix au gramme:</strong> Le prix actuel par gramme d'or.</li>
                                        <li><strong>Calendrier:</strong> Le type d'année utilisé (hijri ou grégorien).</li>
                                    </ul>
                                    <p>D'abord, le poids de l'or est converti en poids effectif d'or pur selon le carat. Ensuite, si le poids pur dépasse 85 grammes, la zakat sur l'or est calculée en utilisant le taux de zakat prescrit:</p>
                                    <ul>
                                        <li><strong>Taux de zakat en calendrier hijri:</strong> 2.5%.</li>
                                        <li><strong>Taux de zakat en calendrier grégorien:</strong> 2.577%.</li>
                                    </ul>
                                    <p>Pour calculer la zakat sur l'or, la valeur calculée est multipliée par les taux de zakat au prix actuel du gramme pour obtenir le montant financier final due.</p>
                                    <p>Cette calculatrice vous fournira les résultats sous forme de rapport contenant:</p>
                                    <ul>
                                        <li>Le poids total d'or pur.</li>
                                        <li>Le seuil de zakat sur l'or.</li>
                                        <li>Le montant de zakat due.</li>
                                    </ul>
                                    <p>
                                        L'or pris en compte pour déterminer le seuil de zakat est le carat 24; car les carats 21, 18 ne sont pas de l'or pur, mais sont mélangés avec d'autres métaux. Si vous avez un autre carat d'or comme 22, 21, 18, 14, 10 ou autres, la zakat n'est due que sur la partie pure.
                                    </p>
                                    <br />
                                    <hr />
                                    <b>Dernière révision : </b>
                                    28/02/2026
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default GoldZakatCalculator;
